export default "__VITE_ASSET__EDfHkt8w__"